// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ColumnHeightOutlinedSvg from "@fishx/icons-svg/es/asn/ColumnHeightOutlined";
import FishxIcon from '../components/FishxIcon';

var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ColumnHeightOutlinedSvg
  }));
};

ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
export default React.forwardRef(ColumnHeightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ColumnHeightOutlined.js
// module id = 2283
// module chunks = 0